import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Screw } from '../../../core';
import { ProductService } from '../../../services';
import { BaseComponent } from '../../../shared';


/**
* Component of table of material list.
*/
@Component({
	selector: 'list-material-table',
	templateUrl: './list-material-table.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ListMaterialTableComponent extends BaseComponent implements OnInit {

	private readonly prodSrv = inject(ProductService);

	screwPlateList: { code: string; description: string; count: number; }[] = [];


	ngOnInit(): void {
		const screwsBom = this.canvasSrv.screwsBom;
		if (screwsBom) {
			const screwList = this.prodSrv.bomScrewList;
			if (screwList) {
				this.populateScrewList(screwList.screwLockingList, screwsBom.screwLockingList);
				this.populateScrewList(screwList.screwNoLockingList, screwsBom?.screwNoLockingList);
			}
		}
		this.prodSrv.bomScrewList = undefined;
	}

	private readonly groupByCounter = (screwLengths: number[]): { [key: number]: number } => {
		const result: { [key: number]: number } = {};
		for (const key of screwLengths) {
			result[key] = (result[key] ?? 0) + 1;
		}
		return result;
	}

	private populateScrewList(screwList: Screw[], screwsBomList?: number[]): void {
		if (screwsBomList?.length) {
			const screwsBomLockCount = this.groupByCounter(screwsBomList);
			for (const length in screwsBomLockCount) {
				if (screwsBomLockCount.hasOwnProperty(length)) {
					const screw = screwList.find(item => item.length === +length);
					if (screw) {
						this.screwPlateList.push({
							code: screw.code,
							description: screw.description,
							count: screwsBomLockCount[length]
						});
					}
				}
			}
		}
	}

}
